import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import React from "react";
import { RouteConfig } from "../../../routes/AuthRoutes";
import { LinkComponent } from "../../shared/LinkComponent";
import { useTranslation } from "react-i18next";
const MagicLinkSuccessComponent = ({}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkComponent, {
    to: RouteConfig.login.loginScreen,
    type: "secondary",
    size: "sm",
    className: "font-semibold flex items-center"
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: "w-5 inline-block mr-1 font-bold"
  }), " ", t("Back to login")));
};
export { MagicLinkSuccessComponent };